import React from 'react'
import coin from '../Assets/coin.png'
import user from '../Assets/background.jpg'

const RecentWins = () => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 '>
      <div className='recent-wins p-4 rounded-lg'>
        <p className='font-bold text-bold text-white p-2'>Recent Winners</p>
        <div className='flex justify-between items-center rounded-lg bg-green-900 p-2 m-2'>
          <p className='font-bold text-bold text-white'>Paid out Prizes</p>
          <p className='font-bold text-2xl text-bold text-green-500'>$20,000</p>
        </div>
        <div className='flex justify-between p-2 m-2'>
          <p className='font-bold text-bold text-white'>Player</p>
          <p className='font-bold text-bold text-white'>Prize</p>
        </div>
        {Array.from({ length: 5 }, (_, i) => (
        <div className='flex justify-between p-2 mt-2'>
          <div className='flex space-x-2'>
          <img style={{ width:'20px', height:'20px', borderRadius:'50%' }}src={user} alt='{}'/>
          <p className='font-bold text-bold text-white'>User</p>
          </div>
          <div className='flex space-x-2'>
          <p className='font-bold text-bold text-green-500'>$600</p>
          <img style={{ width:'25px', height:'25px' }}src={coin} alt='{}'/>
          </div>
        </div>))}
      </div>
      <div className='recent-wins p-4 rounded-lg'>
        <p className='text-white font-bold'>Top Winners</p>
        {Array.from({ length: 4 }, (_, i) => (
        <div className='flex justify-between items-center p-2'>
          <div className='flex justify-center items-center space-x-4'>
            <p className='font-bold text-6xl text-white'>{i + 1}</p>
            <div className='flex flex-col'>
              <p className='font-bold text-white'>mem***363</p>
              <p className='font-bold text-gray-300'>Next Draw: 00h:00m:00s</p>
              <p className='font-bold text-2xl text-green-500'>$44,000</p>
            </div>
          </div>
            <button className='btn-bg rounded-lg p-2 px-4 font-bold bg-green-700'>
              Bet Now
            </button>
        </div>))}
      </div>
    </div>
  )
}

export default RecentWins